export enum MediaType {
  MOBILE_S,
  MOBILE,
  TABLET,
  DESKTOP,
  DESKTOP_L,
}

export enum MediaQuery {
  DESKTOP_L = '(min-width: 1476px)',
  DESKTOP = '(min-width: 1169px) and (max-width: 1475px)',
  TABLET = '(min-width: 1017px) and (max-width: 1168px)',
  MOBILE = '(min-width: 659px) and (max-width: 1016px)',
  MOBILE_S = '(max-width: 658px)',
}

export enum GameItemMode {
  grid,
  random,
  jackpot,
}

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export enum DepositStatusMode {
  Successful = 'success',
  Pending = 'pending',
  Failure = 'failure',
}
